import { SelectOptionType } from '@octano/global-ui';
import { Select } from '@octano/global-ui';
import { Row } from 'reactstrap';

import { Col } from 'reactstrap';
import TutorDetailsBox from './TutorDetailsBox';
import { useTranslation } from 'react-i18next';
import { TutorInfo } from '../../../../StudentManagement/StudentFile/types';

interface StudentAcademicHistoryInfoProps {
  studyPlanEnrollments: SelectOptionType[];
  tutor: TutorInfo | null;
  selectedStudyPlan: SelectOptionType | undefined;
  setSelectedStudyPlan: (option: SelectOptionType | undefined) => void;
}

export default function StudentAcademicHistoryInfo({
  studyPlanEnrollments,
  tutor,
  selectedStudyPlan,
  setSelectedStudyPlan,
}: StudentAcademicHistoryInfoProps) {
  const { t } = useTranslation();

  return (
    <Row className="d-flex justify-content-between mt-3">
      <Col xs={12} md={4} className="pt-3">
        <Select
          name={t('terms:studyPlan.single')}
          options={studyPlanEnrollments}
          label={t('terms:studyPlan.single')}
          placeholder={t('terms:studyPlan.single')}
          value={selectedStudyPlan}
          disabled={studyPlanEnrollments.length === 1}
          isClearable={false}
          onChange={(option) =>
            setSelectedStudyPlan(option as SelectOptionType)
          }
        />
      </Col>
      {tutor && (
        <Col xs={12} md={6} lg={4} className="pt-3">
          <TutorDetailsBox
            tutorName={tutor.names}
            tutorId={tutor.identification}
          />
        </Col>
      )}
    </Row>
  );
}
